export default __webpack_public_path__ + "static/media/kimform-icon.26f35d66.svg";